import React, { useState } from 'react';
import styles from './style.module.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { filtersPastDues, getUniqueCompanyDisplayNames } from '../../../services/kollectaApi';
import { useEffect } from 'react';
import HeaderInternal from '../../../Components/HeaderInternal';
import InputSimple from '../../../Components/InputSimple';
import StatusSelector from '../../../Components/StatusSelector';
import Select from '../../../Components/Select';
import { Button, Table } from '../../../Components';
import formatDocument from '../../../utils/cpf_cnpj';
import parseStatus from '../../../utils/statusParse';
import { parseCurrency } from '../../../utils/currency';
import image from './image.svg';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import Modal from 'react-modal';
import { IoIosClose } from 'react-icons/io';
import CreateQueue from '../../../Components/CreateQueue';
import moment from 'moment';
import MessagingStatusSelector from '../../../Components/MessagingStatusSelector';

const ManagerPastDues = () => {
  const [user, setUser] = useState({});
  const [credores, setCredores] = useState([]);
  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [credor, setCredor] = useState('');
  const [valueFrom, setValueFrom] = useState('');
  const [valueTo, setValueTo] = useState('');
  const [daysFrom, setDaysFrom] = useState('');
  const [daysTo, setDaysTo] = useState('');
  const [hasMessages, setHasMessages] = useState(null);
  const [pastDues, setPastDues] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [totalRecords, setTotalRecords] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [selectedMessagingStatus, setSelectedMessagingStatus] = useState([]);


  const handleInputName = (value) => {
    setName(value);
  }

  const handleInputCpf = (value) => {
    setCpf(value);
  }

  const handleInputPhone = (value) => {
    setPhone(value);
  }

  const handleInputValueFrom = (value) => {
    setValueFrom(value);
  }

  const handleInputValueTo = (value) => {
    setValueTo(value);
  }

  const handleInputDaysFrom = (value) => {
    const stringValue = value.toString();
    const trimmedValue = stringValue.slice(0, -2);
    const intValue = parseInt(trimmedValue, 10);
    setDaysFrom(intValue);
  }

  const handleInputDaysTo = (value) => {
    const stringValue = value.toString();
    const trimmedValue = stringValue.slice(0, -2);
    const intValue = parseInt(trimmedValue, 10);
    setDaysTo(intValue);
  }

  const handleStatusChange = (newStatus) => {
    setSelectedStatus(newStatus);
  };

  const handleInputCredor = (event) => {
    setCredor(event.target.value);
  };

  const handleMessagingStatusChange = (newStatus) => {
    setSelectedMessagingStatus(newStatus);
  };

  const saveSearchResults = (results, filters, totals) => {
    try {
      const currentUser = localStorage.getItem('user');
      if (currentUser) {
        sessionStorage.setItem('managerPastDues_userId', currentUser);
      }
      sessionStorage.setItem('managerPastDues_results', JSON.stringify(results));
      sessionStorage.setItem('managerPastDues_filters', JSON.stringify(filters));
      sessionStorage.setItem('managerPastDues_totals', JSON.stringify(totals));
    } catch (error) {
      console.error('Erro ao salvar resultados:', error);
    }
  };

  const applyValuesIfExist = (data, valueSetterMap) => {
    Object.entries(valueSetterMap).forEach(([key, setter]) => {
      if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
        setter(data[key]);
      }
    });
  };

  const applyValueIfValid = (data, key, setter, validator = null) => {
    const value = data[key];
    if (validator ? validator(value) : (value !== null && value !== undefined && value !== '')) {
      setter(value);
    }
  };

  const restoreSearchResults = () => {
    try {
      const currentUser = localStorage.getItem('user');
      const savedUserId = sessionStorage.getItem('managerPastDues_userId');

      if (!savedUserId || !currentUser || savedUserId !== currentUser) {
        sessionStorage.removeItem('managerPastDues_credores');
        sessionStorage.removeItem('managerPastDues_results');
        sessionStorage.removeItem('managerPastDues_filters');
        sessionStorage.removeItem('managerPastDues_totals');
        sessionStorage.removeItem('managerPastDues_userId');
        return;
      }

      const savedResults = sessionStorage.getItem('managerPastDues_results');
      const savedFilters = sessionStorage.getItem('managerPastDues_filters');
      const savedTotals = sessionStorage.getItem('managerPastDues_totals');

      if (savedResults) {
        const results = JSON.parse(savedResults);
        setPastDues(results);
      }

      if (savedFilters) {
        const filters = JSON.parse(savedFilters);

        const filterMap = {
          name: setName,
          cpf: setCpf,
          phone: setPhone,
          selectedStatus: setSelectedStatus,
          credor: setCredor,
          valueFrom: setValueFrom,
          valueTo: setValueTo,
          daysFrom: setDaysFrom,
          daysTo: setDaysTo,
          selectedMessagingStatus: setSelectedMessagingStatus,
        };

        applyValuesIfExist(filters, filterMap);
        applyValueIfValid(filters, 'hasMessages', setHasMessages,
          (value) => value !== null && value !== undefined
        );
      }

      if (savedTotals) {
        const totals = JSON.parse(savedTotals);

        const totalsMap = {
          totalAmount: setTotalAmount,
          totalRecords: setTotalRecords
        };

        applyValuesIfExist(totals, totalsMap);
      }
    } catch (error) {
      console.error('Erro ao restaurar resultados:', error);
    }
  };

  const getCreditors = async () => {
    const creditors = await getUniqueCompanyDisplayNames();
    if (creditors?.data?.creditors) {
      const options = [
        ...creditors.data.creditors.map(item => ({ value: item.value, label: item.label }))
      ];
      setCredores(options);
    }
    setLoading(false);
  }

  const createObjectAndLog = () => {
    const obj = {};

    if (cpf) obj.personalNumber = cpf;
    if (name) obj.customerName = name;
    if (phone) obj.cellPhone = phone;
    if (selectedStatus && selectedStatus.length > 0) obj.status = selectedStatus;
    if (credor) obj.companyDisplayName = credor;
    if (valueFrom) obj.minValue = valueFrom;
    if (valueTo) obj.maxValue = valueTo;
    if (daysFrom) obj.minDaysPastDue = daysFrom;
    if (daysTo) obj.maxDaysPastDue = daysTo;
    if (hasMessages !== null) obj.hasMessages = hasMessages;
    if (selectedMessagingStatus && selectedMessagingStatus.length > 0) {
      obj.messagingStatus = selectedMessagingStatus;
    }

    return obj;
  }

  const getData = async () => {
    setLoading(true);

    const body = createObjectAndLog();

    try {
      const pastDues = await filtersPastDues(body);
      if (pastDues?.data) {
        setErrorMessage('');
        setLoading(false);
        setTotalAmount(pastDues?.data?.totalOriginalAmount);
        setTotalRecords(pastDues?.data?.totalRecords);
        const results = pastDues?.data?.rows;
        setPastDues(results);

        const filters = {
          name,
          cpf,
          phone,
          selectedStatus,
          credor,
          valueFrom,
          valueTo,
          daysFrom,
          daysTo,
          hasMessages,
          selectedMessagingStatus,
        };
        const totals = {
          totalAmount: pastDues?.data?.totalOriginalAmount,
          totalRecords: pastDues?.data?.totalRecords
        };
        saveSearchResults(results, filters, totals);
        return;
      }
      setLoading(false);

    } catch (error) {
      console.error('Erro ao filtrar débitos', error?.status, error?.data);
      setPastDues([]);
      if (error?.status === 400) {
        setLoading(false);
        return setErrorMessage('Selecione algum filtro válido');
      }

      setLoading(false);
    }

  }

  const handleClearFilters = () => {
    setName('');
    setCpf('');
    setPhone('');
    setSelectedStatus([]);
    setCredor('');
    setValueFrom('');
    setValueTo('');
    setDaysFrom('');
    setDaysTo('');
    setHasMessages(null);
    setPastDues([]);
    setTotalAmount('');
    setTotalRecords('');
    setErrorMessage('');
    setSelectedMessagingStatus([]);
    try {
      sessionStorage.removeItem('managerPastDues_results');
      sessionStorage.removeItem('managerPastDues_filters');
      sessionStorage.removeItem('managerPastDues_totals');
    } catch (err) {
      console.error('Erro ao limpar filtros:', err);
    }
  }

  const tbSettings = [
    { path: 'customerName', center: false, headerName: 'Nome' },
    { path: 'personalNumber', center: false, headerName: 'CPF | CNPJ', columnFormat: (row) => row ? formatDocument(row.personalNumber) : '-' },
    { path: 'companyDisplayName', center: false, headerName: 'Credor' },
    {
      path: 'amount',
      center: false,
      headerName: 'Valor',
      columnFormat: (row) => {
        if (!row) return '-';
        const value = row.amount ?? row.discountAmount ?? '-';
        return parseCurrency(value);
      }
    },
    { path: 'days', center: false, headerName: 'Atraso' },
    {
      path: 'updatedAt',
      center: true,
      headerName: 'Data da última atualização',
      columnFormat: (row) => {
        if (!row || !row.updatedAt) return '-';
        return moment(row.updatedAt).format('DD/MM/YYYY HH:mm');
      }
    },

    { path: 'status', center: true, headerName: 'Status', columnFormat: (row) => row ? parseStatus(row.status) : '-' },
    { path: 'details', center: true, headerName: 'Detalhes' },
  ];

  const closeModal = (item) => {
    setModal(false);
  }



  useEffect(() => {
    getCreditors();
    restoreSearchResults();
  }, []);

  useEffect(() => {
  }, [loading]);

  useEffect(() => {
    const user = localStorage.getItem('user');
    const userParse = JSON.parse(user);
    setUser(userParse);
  }, []);

  useEffect(() => {
  }, [user, name, cpf, phone, selectedStatus, credor, credores, valueFrom, valueTo, daysFrom, daysTo, errorMessage, pastDues, totalAmount, totalRecords, modal]);


  return (
    <div className={styles.searchContainer}>
      <ReactCSSTransitionGroup transitionName="anim"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}>

        <LoadingOverlay isVisible={loading} />

        <div className={styles.top}>
          <HeaderInternal title={user ? user.name : ''} subtitle={user ? user.email : ''} profileImage={true} />
        </div>

        <div className={styles['tab-wrapper']}>
          <div className={styles['tab-group']}>
            <div className={styles['tab-item']}>
              <span>Pesquisa de clientes</span>
            </div>
          </div>

          <main>
            <div className={styles.filtersContainer}>
              <div className={styles.filtersGrid}>
                <div className={styles.filtersContent}>
                  <InputSimple onValueChange={handleInputName} label="Nome" inputType="text" value={name} />

                  <InputSimple onValueChange={handleInputCpf} label="CPF ou CNPJ" inputType="text" value={cpf} />

                  <div className={styles.selectFieldColumn}>
                    <StatusSelector
                      selectedStatus={selectedStatus}
                      handleStatusChange={handleStatusChange}
                      label="Status"
                    />
                  </div>
                  <div className={styles.selectFieldColumn}>
                    <MessagingStatusSelector
                      selectedStatus={selectedMessagingStatus}
                      handleStatusChange={handleMessagingStatusChange}
                      label="Status mensageria"
                    />
                  </div>

                  <InputSimple onValueChange={handleInputPhone} label="Telefone" inputType="text" value={phone} />

                  <div className={styles.radioContainer}>
                    <label className={styles.radioLabel}>Conversa Realizada</label>
                    <div className={styles.radioGroup}>
                      <label>
                        <input
                          type="radio"
                          name="hasMessages"
                          value="true"
                          checked={hasMessages === true}
                          onChange={(e) => setHasMessages(e.target.value === 'true')}
                        />
                        Sim
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="hasMessages"
                          value="false"
                          checked={hasMessages === false}
                          onChange={(e) => setHasMessages(e.target.value === 'true')}
                        />
                        Não
                      </label>
                    </div>
                  </div>
                </div>

                <div className={styles.filtersContent}>
                  <div className={styles.selectFieldColumn}>
                    {credores && credores[0] ? (
                      <Select
                        options={credores}
                        value={credor}
                        onChange={handleInputCredor}
                        label="Credor"
                        fullWidth
                      />
                    ) : null}
                  </div>

                  {/* Valor em atraso */}
                  <div className={styles.subContainer}>
                    <InputSimple onValueChange={handleInputValueFrom} label="Valor em atraso" isCurrency placeholder="De" value={valueFrom} />
                    <InputSimple onValueChange={handleInputValueTo} isCurrency placeholder="Para" value={valueTo} />
                  </div>

                  {/* Dias e atraso em dias */}
                  <div className={styles.subContainer}>
                    <InputSimple onValueChange={handleInputDaysFrom} label="Atraso" placeholder="De" value={daysFrom} />
                    <InputSimple onValueChange={handleInputDaysTo} placeholder="Para" value={daysTo} />
                  </div>

                  <div className={styles.filterActions}>
                    <Button type="button" onClick={getData} className={styles.filterSearchBtn}>
                      Pesquisar
                    </Button>
                    <Button type="button" onClick={handleClearFilters} className={styles.filterClearBtn}>
                      Limpar filtros
                    </Button>
                  </div>

                  <div className={styles.filtersGridCorner} aria-hidden />
                </div>
              </div>
            </div>

            <div className={styles.pastDuesContainer}>
              <h3> Resultado da pesquisa </h3>
              {pastDues.length ?
                <>
                  <Table data={pastDues} tbSettings={tbSettings} handleButtonClick={setModal} user={user} />
                </> : null
              }

              {pastDues.length === 0 ? (
                <div className={styles.empty}>
                  <h3>Sem resultados</h3>
                  <p>Altere os filtros de pesquisa e clique em "Pesquisar" para gerar resultados</p>
                  <img src={image} alt="Lupa pesquisando no CRM" />

                </div>
              ) : null
              }
            </div>
          </main>
        </div>

        {modal &&
          <Modal
            isOpen={modal}
            onRequestClose={closeModal}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
              },
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '8px',
                width: '615px',
              },
            }}
          >
            <div className={styles.modalContainer}>
              <button onClick={() => closeModal(false)} className={styles.close}><IoIosClose /></button>
              <CreateQueue data={pastDues} user={user} totalRecords={totalRecords} totalAmount={parseCurrency(totalAmount)} />
            </div>
          </Modal>
        }
      </ReactCSSTransitionGroup>
    </div>
  )
}

export default ManagerPastDues;